import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import dayjs from 'dayjs';
import OrderService from 'services/order';
import PaymentDetail from 'components/debt/PaymentDetail';
import useIsMobile from '@/hooks/useIsMobile';
import { useOrderDetailScreen } from 'pages/order/Detail';
import { useApp } from 'contexts/app';
import DesktopOrderPayment from './desktop';
import MobileOrderPayment from './mobile';

const orderService = new OrderService();

const OrderPayment = ({ open, onClose }) => {
  const isMobile = useIsMobile(992);
  const { order, loadData } = useOrderDetailScreen();
  const { showNotify } = useApp();

  const [form] = Form.useForm();
  const [paymentHistories, setPaymentHistories] = useState([]);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [savingPayment, setSavingPayment] = useState(false);
  const [updateDebt, setUpdateDebt] = useState({});

  useEffect(() => {
    if (open) {
      loadHistories();
    }
  }, [open, order]);

  useEffect(() => {
    if (showPaymentForm) {
      form.setFieldsValue({
        amount: order?.remain_amount ?? order?.total_amount,
        description: `Thanh toán đơn hàng ${order?.id}`,
        date: dayjs(),
        id: order?.id,
      });
    }
  }, [showPaymentForm, order]);

  const loadHistories = async () => {
    setPaymentHistories([]);
    const lst = await orderService.getPaymentHistory(order.id);
    setPaymentHistories(lst);
  };

  const openPaymentForm = () => setShowPaymentForm(true);
  const closePaymentForm = () => setShowPaymentForm(false);

  const savePayment = async () => {
    const values = await form.validateFields();
    setSavingPayment(true);
    try {
      await orderService.createPayment({ ...values });
      showNotify('Đã ghi nhận thanh toán');
      loadData();
      closePaymentForm();
    } finally {
      setSavingPayment(false);
    }
  };

  const showUpdateDebtModal = (debtId) => {
    setUpdateDebt({ isShow: true, id: debtId });
  };

  const viewModel = {
    open,
    order,
    paymentHistories,
    showPaymentForm,
    savingPayment,
    form,
    openPaymentForm,
    closePaymentForm,
    savePayment,
    onClose,
    showUpdateDebtModal,
  };

  return (
    <>
      {isMobile
        ? <MobileOrderPayment viewModel={viewModel} />
        : <DesktopOrderPayment viewModel={viewModel} />
      }
      <PaymentDetail
        onSaved={() => { loadData(); loadHistories(); }}
        open={updateDebt.isShow}
        id={updateDebt.id}
        onClose={() => setUpdateDebt((prev) => ({ ...prev, isShow: false }))}
      />
    </>
  );
};

export default OrderPayment;